<template>
    <el-dialog
        :visible.sync="visible"
        width="480px"
        append-to-body
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="doClose"
        custom-class="sign-progress"
    >
        <h2>
            {{ title }}
        </h2>
        <div
            v-if="!isReady"
            class="tips"
        >
            <p>未签署的文件，请稍后重试</p>
        </div>
        <div
            v-else-if="signError"
            class="tips"
        >
            <p>请重新发起签署</p>
        </div>
        <div
            v-else-if="percentage !== 100"
            class="tips"
        >
            <p>请勿拔出USB KEY</p>
            <p>请勿关闭证书助手</p>
            <p>请勿关闭此页面</p>
            <p>请确保网络畅通</p>
        </div>
        <el-progress
            v-if="total"
            style="width: 280px;"
            :text-inside="true"
            :stroke-width="20"
            :percentage="percentage"
            color="#409eff"
        />
        <div class="number">
            <span>总：{{ total }}</span>
            <span>已完成：{{ signedUum }}</span>
            <span>未完成：{{ total - signedUum }}</span>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name: 'SignProgress',
    props: {
        visible: Boolean,
        percentage: Number,
        signedUum: Number,
        total: Number,
        signError: Boolean,
        isReady: Boolean,
    },
    computed: {
        title() {
            if (!this.isReady) {
                return '签署失败！';
            }
            return this.signError ? '签署失败！' : (this.percentage !== 100 ? '批量签署中...' : '签署成功！');
        },
    },
    methods: {
        doClose() {
            this.$emit('update:visible', false);
        },
    }
}
</script>
<style lang="less">
.sign-progress {
    .el-dialog__body {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        height: 300px;
        .tips {
            margin-top: 10px;
        }
        p {
            color: red;
            font-size: 14px;
        }
        .number {
            margin-top: 10px;
            width: 280px;
            display: flex;
            justify-content: space-between;
        }
    }
}
</style>